import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';
import Tooltip from 'shopper/components/Tooltip';

import FollowUserButton from 'components/FollowUserButton';
import UserAvatar from 'components/UserAvatar';

import { sendEvent } from 'lib/gtag';
import { toUsernameWithAtSign } from 'lib/user';

import { useUser } from 'providers/UserProvider';

const UserMainInfos = ({
  gaEventCategory,
  userId,
  userName,
  userSpecialtyName,
  userUsername,
  userPhoto,
  userTypeName,
  stats: { userFollowersCount, userFollowingCount },
}) => {
  const { LoggedInUser, isLoggedIn, loadingLoggedInUser } = useUser();

  const onFollowersTextClick = () => {
    sendEvent({ category: gaEventCategory, action: 'click_followers' });
  };

  const onFollowingTextClick = () => {
    sendEvent({ category: gaEventCategory, action: 'click_following' });
  };

  return (
    <div className="flex w-full items-center">
      <UserAvatar
        className="mr-6"
        size="size1"
        userName={userName}
        userPhoto={userPhoto}
        userTypeName={userTypeName}
      />
      <div className="w-full md:w-[45%]">
        <div className="flex items-start justify-between md:justify-normal">
          <div>
            <div className="flex items-center">
              <Heading
                as="h1"
                className="text-neutral-high-200 dark:text-neutral-high-200"
                size="size2"
              >
                {userName}
              </Heading>
              {userSpecialtyName && (
                <Tooltip.Root className="ml-2 md:ml-4">
                  <Tooltip.Trigger>
                    <Icon name="specialist" size="size1" />
                  </Tooltip.Trigger>
                  <Tooltip.Box text={userSpecialtyName}></Tooltip.Box>
                </Tooltip.Root>
              )}
            </div>
            <Heading
              as="span"
              className="mt-2 text-neutral-high-200 dark:text-neutral-high-200"
              size="size6"
            >
              {toUsernameWithAtSign(userUsername)}
            </Heading>
          </div>
          <div className="ml-4 mt-2 flex items-center">
            {!loadingLoggedInUser &&
              isLoggedIn &&
              LoggedInUser?.userId !== userId && (
                <FollowUserButton
                  gaEventCategory={gaEventCategory}
                  size="size4"
                  type="neutral"
                  userId={userId}
                />
              )}
          </div>
        </div>
        <div className="mt-2 flex items-center text-neutral-high-200 dark:text-neutral-high-200">
          <Text
            className="mr-2 text-neutral-high-200 dark:text-neutral-high-200"
            onClick={onFollowersTextClick}
          >
            <b>{userFollowersCount}</b> seguidores
          </Text>
          •
          <Text
            className="ml-2 text-neutral-high-200 dark:text-neutral-high-200"
            onClick={onFollowingTextClick}
          >
            <b>{userFollowingCount}</b> seguindo
          </Text>
        </div>
      </div>
    </div>
  );
};

UserMainInfos.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
  userLevel: PropTypes.number.isRequired,
  userName: PropTypes.string.isRequired,
  userSpecialtyName: PropTypes.string,
  userUsername: PropTypes.string.isRequired,
  userPhoto: PropTypes.string.isRequired,
  userTypeName: PropTypes.string.isRequired,
  stats: PropTypes.shape({
    userFollowersCount: PropTypes.number.isRequired,
    userFollowingCount: PropTypes.number.isRequired,
  }),
};

export default UserMainInfos;
